import { strategyToOptions } from "@/common/utils/strategyToOptions"

export const governmentAllocationCurrencyRestricted = {
  1: 'Sim',
  0: 'Não',
}

export const governmentAllocationCurrencyRestrictedOptions = strategyToOptions(governmentAllocationCurrencyRestricted);
